import './Spacer.css';
import React from 'react';
import classnames from 'classnames';
import GlobalProps from '../globalProps';
import { SpacingSizes } from '../Stack/Stack';

interface Props extends GlobalProps {
  size?: SpacingSizes | 'none';
  width?: number;
}

export function Spacer({ className, style, size = 'default', width }: Props): JSX.Element {
  return <hr className={classnames('spacer', `spacer--${size}`, className)} style={{ ...style, width }} />;
}
